import React, { useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { SideMenu } from "../Side-Menu/sideMenu";
import { useState } from "react";
import axios from "axios";
import { mainServerAppUrl } from "../../apis/mainApi";
import { getAuthUser } from "../Authentication/authHelper";
import { toast } from "react-hot-toast";

export const SubscriptionScreen = () => {
  // const [mealhostId, setMealhostId] = useState(getAuthUser().email);
  const [subscriptionDetails, setSubscriptionDetails] = useState("");
  const [customerDetials, setCustomerDetails] = useState("");
  const [subscriptionId, setSubscriptionId] = useState("");
  const [disabled, setDisabled] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    axios
      .get(mainServerAppUrl + "/mealhost/subscription")
      .then((result) => {
        // console.log(result.data);
        setSubscriptionDetails(result.data.subscriptionDetails);
        setCustomerDetails(result.data.subscriptionDetails.customerDetails);
        setSubscriptionId(result.data.subscriptionDetails.subscriptionId);
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);

  const cancelSubscription = (e) => {
    e.preventDefault();
    setDisabled(true);
    axios
      .delete(mainServerAppUrl + `/v1/subscription/${subscriptionId}`)
      .then((result) => {
        toast.success(result.data.message, { id: "cancelled", duration: 5000 });
        setTimeout(() => {
          navigate("/user-login");
        }, 6000);
        localStorage.clear();
      })
      .catch((error) => {
        console.log(error);
        toast.error(error.response.data.error, {
          id: "not found",
          duration: 3000,
        });
      });
  };

  return (
    <div className="max-resolution">
      <header>
        <div className="header-info">
          <div className="left-part">
            {/* <!-- <img src="common/images/food1.png" className="img-fluid" alt="Register Banner"> --> */}
            <a href="/" className="site-logo">
              <img src={require("../../assets/images/thcm-logo-red.png")} />
            </a>
          </div>
          <div className="right-part">
            <h1>Homey-FOODS</h1>
            <p>
              Throughout human history in all cultures food is an important
              basis of social bonding. With our increasing human family
              worldwide. Homey-FOODS offering a venue for all to enjoy unique
              cuisines, healthy regional foods by many who enjoy cooking and
              eager to serve variety of foods.{" "}
            </p>
            <p>
              <span>
                “Restaurant Meals can increase cardiovascular disease
                risk”Journal of the Academy of Nutrition and Dietetics-March
                2021
              </span>
            </p>
          </div>
        </div>
      </header>
      <section className="title_box">
        <div className="container position-relative">
          {/* <span className="position-relative"> */}
          {/* <SideMenu /> */}
          {/* </span> */}
          <p>
            Use culinary skills offer regional cuisines and become financially
            successful.{" "}
          </p>
          <h2>MEAL HOST - Subscription</h2>
        </div>
      </section>
      <main>
        <div className="container">
          <div className="custom-form centered mb-4">
            <form action="subscription" onSubmit={cancelSubscription}>
              <div className="row">
                <div className="col-12">
                  <input
                    type="text"
                    name="name"
                    value={"Name - " + customerDetials.name}
                    className="w-100 form-control pt-0"
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    name="phone"
                    value={"Phone no. - " + customerDetials.phone}
                    className="w-100 form-control"
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    name="payment"
                    value={
                      "Payment Status - " + subscriptionDetails?.paymentStatus
                    }
                    className="w-100 form-control"
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    name="amount"
                    value={
                      "Amount Paid - " +
                      subscriptionDetails?.totalAmount +
                      " USD"
                    }
                    className="w-100 form-control"
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    name="id"
                    value={"Customer Id - " + subscriptionDetails?.customerId}
                    className="w-100 form-control"
                  />
                </div>
                <div className="col-12">
                  <input
                    type="text"
                    name="susid"
                    value={
                      "SubscriptionID - " + subscriptionDetails?.subscriptionId
                    }
                    className="w-100 form-control"
                  />
                </div>
                <div className="col-12">
                  <button className="btn_form w-100" disabled={disabled}>
                    {" "}
                    CANCEL SUBSCRIPTION
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </main>
      <footer>
        <div className="container">
          <p className="pb-2">DISCLAIMER</p>
          <p>
            Homey-FOODS is a service that brings Meal Hosts and Patrons
            together. Homey-FOODS makes no representations, endorsements. or
            warranties of any kind whatsoever of Meal Hosts and Customers. Both
            parties agree to comply to local government laws, be of legal age
            and Homey-FOODS shall not be held responsible from disputes, damages
            and controversies.
          </p>
          <div className="footer_bottom text-center">
            <a href="https://www.homey-foods.com" className="site_link my-3">
              www.homey-foods.com
            </a>
            <div className="social-media">
              <ul>
                <li>
                  <a href="#" target="_blank">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i className="fab fa-linkedin"></i>{" "}
                  </a>
                </li>
                <li>
                  <a href="#" target="_blank">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              </ul>
            </div>
            <p>© 2023 Homey-FOODS</p>
          </div>
        </div>
      </footer>
    </div>
  );
};
